import React from "react";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import logo from "../../images/naimLogo.png";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light NavBG">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img className="logo" src={logo} alt="logo..." />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={faBars} style={{ color: "white" }} />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#about">
                About Me
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#skills">
                Skills
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#projects">
                Projects
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blogs">
                Blogs
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#contact">
                Contact Me
              </a>
            </li>
            <li className="nav-item">
              <a
                className="btn btn-danger"
                href="https://drive.google.com/u/1/uc?id=1SpIfpE_wf9KgskJNhql98o8GIMvqOyT2&export=download"
              >
                Resume
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
